export class MemoryStorage {
    constructor() {
        this.storage = new Map();
    }
    get length() {
        return this.storage.size;
    }
    clear() {
        this.storage.clear();
    }
    getItem(key) {
        return this.storage.get(key) ?? null;
    }
    key(index) {
        return [...this.storage.keys()][index];
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
}
//# sourceMappingURL=memory.storage.js.map